module.exports = [() => ({
  require: 'ngModel',
  link(scope, element, attributes, ngModel) {
    const PATIENT_PASSWORD_REGEXP = /^(?=.*[0-9])(?=.*[A-Z]).{2,}$/;

    ngModel.$validators.passwordRequirements = modelValue => (modelValue ? modelValue.match(PATIENT_PASSWORD_REGEXP) !== null : true);

    scope.$watch('otherModelValue', () => ngModel.$validate());
  },
})];



// WEBPACK FOOTER //
// ./main/directives/password-requirements.js